/* Current native-offer information only. Never touches forms or app-owned nodes. */
(() => {
  'use strict';
  if (window.PMVStoqReservedInformation) return;
  let frame = 0, timer = 0, stopped = false, nativeSignature = null;
  const root = document.getElementById('MainContent');
  if (!root) return;
  function selectedProductVariant(context) {
    // The hidden sticky and installment forms can still hold a prior variant.
    const forms = context?.querySelectorAll('.product__buy-buttons > product-form > form[data-type="add-to-cart-form"]');
    if (forms?.length !== 1) return null;
    const inputs = forms[0].querySelectorAll('input[name="id"]');
    // A disabled main input remains the selected identity for sold-out information.
    return inputs.length === 1 ? String(inputs[0].value || '') : null;
  }
  function visible(node) {
    if (!node?.getClientRects().length) return false;
    for (let n = node; n && n.nodeType === 1; n = n.parentElement) {
      const style = getComputedStyle(n);
      if (n.hidden || n.getAttribute('aria-hidden') === 'true' || style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    return true;
  }
  function refresh() {
    frame = 0; clearTimeout(timer);
    let next = Infinity;
    for (const panel of root.querySelectorAll('[data-pmv-stoq-info]')) {
      const context = panel.closest('.product__info-container');
      if (!context) continue;
      const selected = selectedProductVariant(context);
      const nativeCard = [...context.querySelectorAll('.restock-rocket-preorder-description')].some(visible);
      const end = panel.dataset.end ? Date.parse(panel.dataset.end) : Infinity;
      const expired = !Number.isFinite(end) && end !== Infinity || end <= Date.now();
      const hide = selected !== panel.dataset.variantId || nativeCard || expired;
      if (panel.hidden !== hide) panel.hidden = hide;
      if (!expired && Number.isFinite(end)) next = Math.min(next, end - Date.now());
    }
    const signature = [...root.querySelectorAll('.product__info-container')].map(context =>
      (selectedProductVariant(context) || '') + ':' +
      [...context.querySelectorAll('.restock-rocket-preorder-button')].some(button => !button.disabled && visible(button)) + ':' + [...context.querySelectorAll('[data-pmv-stoq-info]')].some(visible)
    ).join('|');
    if (nativeSignature !== signature) {
      nativeSignature = signature;
      document.dispatchEvent(new Event('pmv:stoq-lifecycle'));
    }
    if (Number.isFinite(next)) timer = setTimeout(schedule, Math.min(Math.max(1, next), 2147483647));
  }
  function schedule() { if (!stopped && !frame) frame = requestAnimationFrame(refresh); }
  const observer = new MutationObserver(schedule);
  observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'hidden', 'style', 'class', 'aria-hidden', 'disabled', 'data-end', 'data-variant-id']});
  root.addEventListener('change', schedule, true);
  root.addEventListener('input', schedule, true);
  window.addEventListener('popstate', schedule);
  window.PMVStoqReservedInformation = { refresh: schedule, destroy() { stopped = true; observer.disconnect(); clearTimeout(timer); cancelAnimationFrame(frame); root.removeEventListener('change', schedule, true); root.removeEventListener('input', schedule, true); window.removeEventListener('popstate', schedule); } };
  schedule();
})();
